const config = {
  appName: import.meta.env.VITE_APP_NAME || 'Approval System',
  appTagline: import.meta.env.VITE_APP_TAGLINE || 'McMaster University',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '',
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY || '',
} as const

export default config
